import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {EventService} from "../../services/event.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
  styleUrls: ['./event-dialog.component.scss']
})
export class EventDialogComponent {

  public events: any[] = [
    {
      name: 'Kaufabsicht abrufen',
      type: 'purchase_intent',
    },
    {
      name: 'Kaufabsichten abrufen',
      type: 'purchase_intents',
    }
  ];

  public event = "";

  public type = "update";
  public eventData: any = {};
  public value = "";
  public id = "";
  public loading = false;

  constructor(
    private matDialog: MatDialog,
    private eventService: EventService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.eventData = data.event;
      this.type = data.type;
      this.value = data.event[data.field];
    }
  }

  onCancel() {
    this.matDialog.closeAll();
  }

  onOk() {
    this.loading = true;
    const event = this.events.find(event => event.type === this.event);
    event.value = JSON.stringify({
      id: this.id
    });
    event.customerId = '1';
    event.externalId = this.id;
    this.eventService.createEvent(event).subscribe(() => {
      this.loading = false;
      this.openSnackBar('Event wurde erfolgreich angetriggert.');
      this.matDialog.closeAll();
    });
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 4000,
    });
  }

}
